<template>
    <div class="blogPosts-content zblock">
        <!-- Block title -->
        <h4 class="zblock__title" v-if="blockdatas.block_title">{{ blockdatas.block_title }}</h4>

        <!--  --------------------------------------
                Carouel Blog articles
        ---------------------------------------  -->
        <VueSlickCarousel v-bind="settingForBlogHomeZBlock" class="blogPosts__list">
            <div class="blogPosts__item" v-for="(article, index) in articlesArray" :key="index">
                <a :href="baseUrl + article.link" target="blank">
                    <h5>
                        <span class="overlay"></span>
                        {{ article.title }}
                    </h5>
                    <img :src="`${baseUrl}media/${article.background}`" alt="background image" />
                    <div class="overlay"></div>
                </a>
            </div>
        </VueSlickCarousel>

        <!-- Button link to Blog home page -->
        <div class="blogPosts__btn"><a :href="blockdatas.button_link" target="blank">{{ blockdatas.button_label }}</a></div>
        
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import galleryMixin from "@/mixins/galleryMixin";

export default {
    name: 'BlogPosts',

    components: {
        VueSlickCarousel,
    },

    mixins: [galleryMixin],

    props: ["blockdatas"],

    data() {
        return {
            baseUrl: process.env.VUE_APP_API_BASE_URL + '/',
            articlesArray: Object.values(this.blockdatas.articles),
        };
    },

}
</script>

<style lang="scss" scoped>
    .blogPosts-content {
        margin: 80px 0 60px;
        text-align: center;
    }

    h4.zblock__title{
        margin: 40px 0;
        text-align: center;
        font-size: 3rem;
        font-weight: 800; 
    }

    .blogPosts__list {
        width: 90vw;
        max-width: 1170px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }

    .blogPosts__item {
        position: relative;
        max-width: 270px;
        margin: 15px 5px;

        a {
            display: flex;
            height: 270px;
            justify-content: center;
            align-items: center;
            text-align: center;
        
            h5 {
                position: relative;
                width: 100%;
                padding: 5px 0;
                font-size: 2.2rem;
                color: $color-white;
                z-index: 2;

                // Hover title overlay animation
                span.overlay {
                    z-index: -1;
                    transform: scaleX(0);
                    transform-origin: center;
                    transition: transform .2s ease-in;
                    border-top: 1px solid white;
                    border-bottom: 1px solid
                }
            }

            img,
            .overlay {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
            }

            .overlay {
                background-color:rgba(0,0,0,.3);
            }

            &:hover {
                // Hover article overlay
                div.overlay {
                    opacity: 0;
                }

                // Hover title overlay animation
                span.overlay {
                    transform: scaleX(1);
                }
            }
        }
    }

    // Button link to Blog home page
    .blogPosts__btn {
        display: inline-block;
        margin: 25px auto;
        background-color: #FAFAFA;
        border-radius: 32px;

        a {
            display: block;
            padding: 15px 25px;
            text-transform: uppercase;

            &:hover {
                color: $color-red;
            }
        }
    }
</style>
